
export default class LearningContinue {
  itemSize: number;
  currentIndex: number;
  currentPage: number;

  constructor(itemSize: number, currentIndex: number, currentPage: number) {
    this.itemSize = itemSize;
    this.currentIndex = currentIndex;
    this.currentPage = currentPage;
  }
}
